/**
 * @file SEC
 * @author yuanyaojia<yuanyaojia@baijia.com>
 * @date 2021-4-21
 */

import http from './http';
import constant from './constant';

/**
  * 获取sec文件列表
  * url: /sec/list.json
  * 方法：POST
  */

export const getSecList = params => http.post(constant.SEC.GET_SEC_LIST, params);

/**
  * 获取sec文件详情
  * url: /sec/info.json
  * 方法：POST
  */

export const getSecInfo = params => http.post(constant.SEC.GET_SEC_INFO, params);
